import { UpdateKeyOptions } from './../models/agents/update-key-options';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AgentRegister } from '../models/agents/agent-register';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { DatePipe } from '@angular/common';
import { RegistrationHistory } from '../models/agents/registration-history';
import { InvitationRegister } from '../models/agents/invitation-register';
import { Invitation } from '../models/agents/invitation.ts';
import { TwoFactorInvitation } from '../models/agents/two-factor-invitation';
import { TokenResult } from '../models/agents/token-result';
import { CheckToken } from '../models/agents/check-token';
import { RegistrationTrack } from '../models/agents/registration-track';
import { UpdateAgentStatus } from '../models/agents/update-agent-status';
import { RegistrationAnalysisPaged } from '../models/agents/registration-analysis-paged';
import { RegistrationPagedSearchTermInput } from '../models/agents/input/registration-paged-input';
import { AgentFullRegistration } from '../models/agents/agent-full-registration';
import { RegistrationControlItem } from '../models/enums/registration-control-item.enum';
import { Store } from '@ngxs/store';
import { PersonService } from './person.service';
import { CompanyService } from './company.service';
import { InitPersonFromServer } from '../state-manager/actions/person-register.action';
import { PersonType } from '../models/enums/person-type.enum';
import { InitCompanyFromServer } from '../state-manager/actions/company-register.action';
import { of } from 'rxjs/observable/of';
import { catchError, map, mergeMap, share } from 'rxjs/operators';
import { ApplyAgentInformation } from '../state-manager/actions/suitability-score.action';
import { SuitabilityScoreBehaviorService } from '../state-manager/behavior-subjects/suitability-behavior.service';
import { InvitationOutput } from '../models/agents/output/invitation-output';
import { PostAgentOutput } from '../models/agents/output/post-agent-output';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ExpirationOutput } from '../models/agents/output/expiration-output';
import { User } from '../models/auth/user';
import { AuthState } from '../state-manager/state/auth.state';
import { RegistrationInfoOutput } from '../models/registration/registration-info-output';
import { LatestInvitationOutput } from '../models/agents/output/latestInvitationOutput';
import { CheckInvitationOuput } from '../models/invites/CheckInvitationOutput';
import RegisterUpdateOutput from '../models/registration/register-update-output';
import { InvestorRepresentative } from '../models/agents/investor-representative';
import { get } from 'lodash';
import MsCotista from './graphql/msCotista';
import GetAdhesionContracsInput from '../models/adhesion/GetAdhesionContractsInputs';
import GetAdhesionContractsOutput from '../models/adhesion/GetAdhesionContractsOutput';
import RegisterUpdateInput from '../models/registration/register-update-input';
import { UpdateUserInput } from '../models/agents/input/update-user-input';
import {
  DistributorResponse,
  DistributorsPagedResponse,
  Providers
} from '../models/registration/distributors-info-output';
import GetNonConformityTermInput from '../models/nonConformityTerm/GetNonConformityTermInput';
import GetNonConformityTermOutput from '../models/nonConformityTerm/GetNonConformityTermOutput';
import { SelectDynamic } from '../models/agents/dynamic-select-list';
import { throwError } from 'rxjs';

@Injectable()
export class RegistrationService {
  registration: RegistrationHistory[] = [
    { currentStep: RegistrationControlItem.InvestorData, stepUrl: 'data' },
    { currentStep: RegistrationControlItem.ContractData, stepUrl: 'contract' },
    { currentStep: RegistrationControlItem.Address, stepUrl: 'address' },
    {
      currentStep: RegistrationControlItem.PaymentAccountOpening,
      stepUrl: 'payment-account-opening'
    },
    {
      currentStep: RegistrationControlItem.Representatives,
      stepUrl: 'representatives'
    },
    {
      currentStep: RegistrationControlItem.EconomicGroup,
      stepUrl: 'economic-group'
    },
    { currentStep: RegistrationControlItem.Profession, stepUrl: 'profession' },
    { currentStep: RegistrationControlItem.Partner, stepUrl: 'partner' },
    { currentStep: RegistrationControlItem.BankData, stepUrl: 'bank' },
    {
      currentStep: RegistrationControlItem.AuthorizationsDeclarations,
      stepUrl: 'authorizations'
    },
    {
      currentStep: RegistrationControlItem.SuitabilityProduct,
      stepUrl: 'suitability/product-suitability'
    },
    {
      currentStep: RegistrationControlItem.SuitabilitySituation,
      stepUrl: 'suitability/financial-situation'
    },
    {
      currentStep: RegistrationControlItem.SuitabilityKnowledge,
      stepUrl: 'suitability/financial-knowledge'
    },
    {
      currentStep: RegistrationControlItem.Suitability,
      stepUrl: 'suitability'
    },
    {
      currentStep: RegistrationControlItem.Confirmations,
      stepUrl: 'confirmations'
    },
    {
      currentStep: RegistrationControlItem.InvestorRepresentative,
      stepUrl: 'relationship'
    },
    { currentStep: RegistrationControlItem.FiscalData, stepUrl: 'fiscal-data' },
    {
      currentStep: RegistrationControlItem.BeneficiariesData,
      stepUrl: 'beneficiaries'
    },
    {
      currentStep: RegistrationControlItem.ProductPortfolio,
      stepUrl: 'assets-portfolio'
    },
    {
      currentStep: RegistrationControlItem.FinancialInformation,
      stepUrl: 'financial-information'
    },
    { currentStep: RegistrationControlItem.Patrimonial, stepUrl: 'patrimonial' }
  ];

  userLogged: User;

  constructor(
    protected http: HttpClient,
    protected personService: PersonService,
    protected companyService: CompanyService,
    protected suitabilityScoreService: SuitabilityScoreBehaviorService,
    public store: Store,
    public datepipe: DatePipe,
    protected msCotista: MsCotista
  ) {
    setTimeout(() => {
      this.getUserLogged();
    }, 1000);
  }

  getUserLogged() {
    this.store.select(AuthState.User).subscribe((user) => {
      this.userLogged = user;
    });
  }

  registerAgent(agent: AgentRegister): Observable<PostAgentOutput> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent;

    return this.http.post<PostAgentOutput>(url, agent);
  }

  sendEmail(
    agentID: String,
    status: Number,
    returnReasons: String,
    sendEmail: boolean
  ) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.approveDisapprove +
      '/' +
      get(this.userLogged, 'userID');
    return this.http.post<PostAgentOutput>(url, {
      registerDto: { agentID, returnReasons, status, sendEmail }
    });
  }

  agentByInvite(invite: string): Observable<AgentRegister> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agentByInvite +
      '/' +
      invite;
    return this.http.get<AgentRegister>(url).pipe(
      map((res) => new AgentRegister(res)),
      catchError((err) => throwError(err))
    );
  }

  agentById(invite: string): Observable<AgentRegister> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agentById +
      '/' +
      invite;
    return this.http.get<AgentRegister>(url).pipe(
      map((res) => new AgentRegister(res)),
      catchError((err) => throwError(err))
    );
  }

  sendFinalStepEmail(email: String) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.sendRepresentativeFinalStepEmail;

    return this.http.post(url, { email });
  }

  sendFirstStepEmail(email: String, name: String, document: String) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.sendRepresentativeFirstStepEmail;

    return this.http.post(url, { email, name, document });
  }

  getAgentByInvitationId(
    Id: string
  ): Observable<AgentRegister> {
    const params = new HttpParams()
      .set('InvitationId', Id);

    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent;

    return this.http
      .get(url, { params })
      .pipe(map((response: any) => response.agents[0]));
  }

  getAgentByDocument(
    document: string,
    distributor: string
  ): Observable<AgentRegister> {
    const params = new HttpParams()
      .set('Document', document)
      .set('Distributor', distributor ? distributor : '');

    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent;

    return this.http.get(url, { params }).pipe(
      map((response: any) => response.agents[0]),
      map((res) => new AgentRegister(res)),
      catchError((err) => throwError(err))
    );
  }

  getRegistrationItem(item: RegistrationControlItem): RegistrationHistory {
    return this.registration.find((args) => args.currentStep === item);
  }

  updateRegisterDate(
    agentId: string,
    registerDate: string,
    riskLevel: string,
    distributor: Providers
  ) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent +
      '/' +
      get(this.userLogged, 'userID');

    const operations = [];

    operations.push({
      op: 'replace',
      path: '/RegisterDate',
      value: registerDate
    });
    operations.push({ op: 'replace', path: '/RiskLevel', value: riskLevel });

    if (distributor) {
      operations.push({
        op: 'replace',
        path: '/Distributor',
        value: {
          Name: distributor.nome,
          Document: distributor.cnpj
        }
      });
    }

    return this.http.patch(url, {
      agentID: agentId,
      agentPatch: operations
    });
  }

  updateDistributor(agentId: string, distributor: Providers) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent +
      '/' +
      get(this.userLogged, 'userID');

    const operations = [
      { op: 'replace', path: '/Distributor/Name', value: distributor.nome },
      { op: 'replace', path: '/Distributor/Document', value: distributor.cnpj }
    ];

    return this.http.patch(url, {
      agentID: agentId,
      agentPatch: operations
    });
  }

  createDistributor(agentId: string, distributor: Providers) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent +
      '/' +
      get(this.userLogged, 'userID');

    const operations = [
      {
        op: 'add',
        path: '/Distributor',
        value: {
          Name: distributor.nome,
          Document: distributor.cnpj
        }
      }
    ];

    return this.http.patch(url, {
      agentID: agentId,
      agentPatch: operations
    });
  }

  updateProcessAgentById(agentId: string, updateProcess: boolean) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent +
      '/' +
      get(this.userLogged, 'userID');

    return this.http.patch(url, {
      agentID: agentId,
      agentPatch: [
        { op: 'replace', path: '/UpdateProcess', value: updateProcess }
      ]
    });
  }

  getUsersByInvitation(invitationId: string, invitationHash: string) {
    const url = environment.apiCadastroSettings.url + environment.apiCadastroSettings.getUsersByInvitation + invitationId;

    return this.http.get(url, {
      headers: { AuthorizationHash: invitationHash }
    });
  }

  updateEmailByDocumentPortal(payload: UpdateUserInput) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.userUpdateEmailByDocumentPortal;

    return this.http.put(url, payload);
  }

  getUserByEmailPortal(email: string) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.getUserByEmailPortal +
      email;

    return this.http.get(url);
  }

  getAdhesionContract(
    input: GetAdhesionContracsInput
  ): Observable<GetAdhesionContractsOutput> {
    const query = this.msCotista.getAdhesionContracts;
    const url = environment.msCotista;

    return this.http.post<GetAdhesionContractsOutput>(url, {
      query,
      variables: input
    });
  }

  getNonConformityTerm(
    input: GetNonConformityTermInput
  ): Observable<GetNonConformityTermOutput> {
    const query = this.msCotista.getNonConformityTerm;
    const url = environment.msCotista;

    return this.http.post<GetNonConformityTermOutput>(url, {
      query,
      variables: input
    });
  }

  getCSV(email: string) {
    const params = new HttpParams().set('destinationEmail', email);
    const url = `${environment.apiCadastroSettings.url}${environment.apiCadastroSettings.csv}`;
    this.http.get(url, { params, responseType: 'text' }).subscribe();
  }

  checkInvitation(invitationRegister: InvitationRegister) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.senderInvitation;

    invitationRegister.check = true;
    return this.http.post<CheckInvitationOuput>(url, invitationRegister);
  }

  updateNotApprovedRegisterDate(
    agentId: string,
    notApprovedRegisterDate: string
  ) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agent +
      '/' +
      get(this.userLogged, 'userID');

    return this.http.patch(url, {
      agentID: agentId,
      agentPatch: [
        {
          op: 'replace',
          path: '/NotApprovedRegisterDate',
          value: notApprovedRegisterDate
        }
      ]
    });
  }

  getRegistrationInfo(
    isDistributorVortxActive: boolean
  ): Observable<RegistrationInfoOutput> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.registrationsInfo +
      `?DistributorVortx=${isDistributorVortxActive}`;

    return this.http.get<RegistrationInfoOutput>(url).pipe(share());
  }

  getFundDistributorsInfo(cnpj: string): Observable<DistributorResponse> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.distributorsInfo +
      `?FundDocument=${cnpj}`;

    return this.http
      .get<DistributorResponse>(url)
      .pipe(share())
      .catch((e, caught) =>
        Observable.throw({ error: 'Erro ao selecionar distribuidores' })
      );
  }

  getFundDistributorsPaged(
    Page: number,
    Limit: number
  ): Observable<DistributorsPagedResponse> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.distributorsPaged +
      `?page=${Page}&limit=${Limit}`;

    return this.http
      .get<DistributorsPagedResponse>(url)
      .pipe(share())
      .catch((e, caught) =>
        Observable.throw({ error: 'Erro ao selecionar distribuidores' })
      );
  }

  sendInvitation(
    invitationRegister: InvitationRegister
  ): Observable<InvitationOutput> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.senderInvitation;

    invitationRegister.check = false;
    return this.http.post<InvitationOutput>(url, invitationRegister);
  }

  removeInvitation(id: string): Observable<{ message: string }> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.removeInvitation +
      '/' +
      get(this.userLogged, 'userID') +
      '/' +
      id;

    return this.http.delete<{ message: string }>(url);
  }

  latestInvitation(httpParams: HttpParams): Observable<LatestInvitationOutput> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.latestInvitation;
    return this.http.get<LatestInvitationOutput>(url, { params: httpParams });
  }

  invitationById(invitationID: string): Observable<Invitation> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.invitationById +
      '/' +
      invitationID;
    return this.http.get<Invitation>(url);
  }

  sendTwoFactorAuthentication(twoFactorInvitation: TwoFactorInvitation) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.sendTwoFactorAuthentication;
    return this.http.post(url, twoFactorInvitation, {
      headers: {
        AuthorizationHash: twoFactorInvitation.hash
      }
    });
  }

  checkTokenInvitation(token: CheckToken): Observable<TokenResult> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.checkTokenInvitation;
    return this.http.post<TokenResult>(url, token, {
      headers: {
        AuthorizationHash: token.hash
      }
    });
  }

  insertNewTrack(
    registrationTrack: RegistrationTrack
  ): Observable<RegistrationHistory[]> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.insertRegistrationHistory +
      '/' +
      get(this.userLogged, 'userID');

    return this.http.post<RegistrationHistory[]>(url, registrationTrack);
  }

  updateAgentStatus(invitationStatus: UpdateAgentStatus): Observable<any> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.updateAgentStatus +
      '/' +
      get(this.userLogged, 'userID');

    return this.http.post<AgentRegister>(url, invitationStatus);
  }

  registerUpdate(items: RegisterUpdateInput): Observable<RegisterUpdateOutput> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.registerUpdate +
      '/' +
      get(this.userLogged, 'userID');

    return this.http.post<RegisterUpdateOutput>(url, { ...items });
  }

  updateAgentOptions(invitationOptions: UpdateKeyOptions): Observable<any> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.updateKeyOptions;
    return this.http.post(url, invitationOptions);
  }

  getRegistrationsPaged(
    httpParams: HttpParams
  ): Observable<RegistrationAnalysisPaged> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.registrationsPaged;
    return this.http.get<RegistrationAnalysisPaged>(url, {
      params: httpParams
    });
  }

  getUnfresh(
    httpParams: HttpParams,
    unfreshFilter: any
  ): Observable<ExpirationOutput> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.expirations +
      `?DistribuidorVortx=${unfreshFilter.isDistributorVortxActive}`;
    return this.http.get<ExpirationOutput>(url, { params: httpParams });
  }

  getRegistrationsBySearchTerm(
    registrationPagedInput: RegistrationPagedSearchTermInput
  ): Observable<RegistrationAnalysisPaged> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.registrationsSearchTerm;
    return this.http.post<RegistrationAnalysisPaged>(
      url,
      registrationPagedInput
    );
  }

  getAgentFullRegistration(agentId: string): Observable<AgentFullRegistration> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.agentFullRegistration +
      '/' +
      agentId;
    return this.http.get<AgentFullRegistration>(url);
  }

  onbaseIntegration(agentId: string) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.onbaseIntegration +
      '/' +
      agentId;
    return this.http.post(url, {});
  }

  private InitPerson(
    agent: AgentRegister,
    invitation: Invitation
  ): Observable<any> {
    const observable = new Observable((observer) => {
      this.personService.getPersonByAgent(agent.id).subscribe(
        (person) => {
          this.store.dispatch(
            new InitPersonFromServer(
              person,
              agent.id,
              agent.registrationHistory,
              invitation
            )
          );
          observer.next({ type: PersonType.Fisica, person });
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
    return observable;
  }

  private InitCompany(
    agent: AgentRegister,
    invitation: Invitation
  ): Observable<any> {
    const observable = new Observable((observer) => {
      this.companyService.getCompanyByAgent(agent.id).subscribe(
        (company) => {
          this.store.dispatch(
            new InitCompanyFromServer(
              company,
              agent.id,
              agent.registrationHistory,
              invitation
            )
          );
          observer.next({ type: PersonType.Juridica, company });
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
    return observable;
  }

  restoreStateByInvitation(invitationID: string): Observable<any> {
    const self = this;
    return forkJoin([
      self.agentByInvite(invitationID),
      self.invitationById(invitationID)
    ]).pipe(mergeMap(this.mergeForks, this.withInvitationSelector));
  }

  mergeForks = (forks) => {
    const agent = forks[0];
    const invitation = forks[1];
    return this.restoreState(agent, invitation);
  }

  saveFingerprint(agentId: string, fingerprint: string, type: string) {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.saveFingerprint;

    return this.http.post(url, {
      agentId,
      fingerprint,
      type
    });
  }

  withInvitationSelector = (response: any, register: any) => {
    const agent = response[0];
    const invitation = response[1];
    if (agent) {
      const payload = { agentId: agent.id, personType: agent.personType };
      this.store.dispatch(new ApplyAgentInformation(payload));
      this.setSuitabilityScore(agent, register);
    }
    return { agent, register, invitation };
  }

  updateInvestorRepresentative(representative: InvestorRepresentative) {
    const url =
      environment.apiCadastroSettings.url +
      '/' +
      environment.apiCadastroSettings.investorRepresentative +
      '/' +
      get(this.userLogged, 'userID');

    return this.http.post(url, representative);
  }

  setSuitabilityScore(agent: AgentRegister, register: any) {
    if (agent.personType === PersonType.Fisica) {
      const person = register.person;
      if (
        person &&
        person.suitability &&
        person.suitability !== null &&
        person.suitability.track
      ) {
        this.suitabilityScoreService.setPontuation(person.suitability.track);
      }
    } else {
      const company = register.company;
      if (
        company &&
        company.suitability &&
        company.suitability !== null &&
        company.suitability.track
      ) {
        this.suitabilityScoreService.setPontuation(company.suitability.track);
      }
    }
  }

  restoreState(
    agentRegister: AgentRegister,
    invitation: Invitation = null
  ): Observable<any> {
    if (!agentRegister) {
      return of({});
    }

    if (agentRegister.personType === 'Pessoa Física') {
      return this.InitPerson(agentRegister, invitation);
    } else {
      return this.InitCompany(agentRegister, invitation);
    }
  }

  removeRegisterByAgentId(agentId: string): Observable<{ message: string }> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.removeRegister +
      '/' +
      get(this.userLogged, 'userID') +
      '/' +
      agentId;

    return this.http.delete<{ message: string }>(url);
  }
}
